import { Badge } from "@chakra-ui/react";
import React from "react";

function FormSubmittedStatus({
  requiresResubmission,
  hasBeenSubmitted,
}: {
  hasBeenSubmitted: boolean;
  requiresResubmission: boolean | undefined;
}) {
  if (hasBeenSubmitted && !requiresResubmission) {
    return <Badge colorScheme="green">Submitted</Badge>;
  } else if (hasBeenSubmitted && requiresResubmission) {
    return <Badge colorScheme="red">Requires resubmission</Badge>;
  } else {
    return null;
  }
}

export default FormSubmittedStatus;
